export const emptyAlbumDraft = { label: '', url: '', visibility: 'owner' };

/** Validates the optional album collected before a Trip or Hike has an ID. */
export function validateAlbumDraft(draft) {
  const label = draft.label.trim();
  const url = draft.url.trim();
  if (!label && !url) return true;
  if (!label || label.length > 80 || !url || url.length > 2048) return false;
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase();
    return parsed.protocol === 'https:' && !parsed.username && !parsed.password && host.includes('.') &&
      !host.endsWith('.local') && !/^\d+(?:\.\d+){3}$/.test(host);
  } catch { return false; }
}

/** Persists an optional draft after the entry create mutation returns its ID. */
export async function saveCreatedAlbumLink(mutate, hobbyId, entryId, draft) {
  if (!draft?.label?.trim() && !draft?.url?.trim()) return;
  await mutate({ variables: { input: {
    hobbyId, entryId, label: draft.label.trim(), url: draft.url.trim(), visibility: draft.visibility === 'shared' ? 'shared' : 'owner',
  } } });
}
